import React from 'react';
import PropTypes from 'prop-types';
import AdvertiserCampaignSelect from './AdvertiserCampaignSelect';
import AffiliateSelect from './AffiliateSelect';

export default class DestinationSelect extends React.Component {
  static propTypes = {
    virtualLineMover:         PropTypes.object,
    updateAdvertiserCampaign: PropTypes.func,
    updateAffiliateCampaign:  PropTypes.func
  };

  render() {
    const { virtualLineMover, updateAdvertiserCampaign, updateAffiliateCampaign } = this.props;
    const destinationCampaign = virtualLineMover.destinationCampaign;

    return (
      <div>
        <AdvertiserCampaignSelect
          uniqueNameField={destinationCampaign.advertiserCampaignId}
          destinationCampaign={destinationCampaign}
          changeListener={updateAdvertiserCampaign.bind(this)}
          errorMessages={this.applyErrorToSelect("advertiser")}
        />
        { destinationCampaign.requiresAffiliate &&
          <AffiliateSelect
            uniqueNameField={destinationCampaign.affiliateId}
            destinationCampaign={destinationCampaign}
            nameLabel={destinationCampaign.affiliateLabel}
            advertiserCampaignId={destinationCampaign.advertiserCampaignId}
            key={destinationCampaign.advertiserCampaignId}
            changeListener={updateAffiliateCampaign.bind(this)}
            errorMessages={this.applyErrorToSelect("affiliate")}
          />
        }
      </div>
    );
  }

  applyErrorToSelect(orgType) {
    const { virtualLineMover } = this.props;
    const destinationCampaign = virtualLineMover.destinationCampaign;
    const destinationErrors = virtualLineMover.destinationSelectError();
    const errorMessage = [].concat(destinationErrors, virtualLineMover.destinationCampaign.selectErrors).filter(error => error);

    if (errorMessage.length > 0 && ((orgType === "advertiser" && !destinationCampaign.requiresAffiliate) || orgType === "affiliate")) {
      return errorMessage;
    }
  }
}
